<template>  
<div> <!-- root element start -->

  <div class="row">
    <div class="col-12">

      <div class="card border-0">
        <div class="card-header h5 bg-transparent border-0">Change Profile</div>
        <div class="card-body">

              <hr class="bg-dark">

              <div class="row"><!--  email row -->

                <div class="col-md-3 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Customer Facing Email</span>
                </div>

                <div class="col-md-6">
                  <div class="row">
                    <div class="form-group col-12">
                      <label class="d-none d-md-block" for="exampleInputEmail1">Email</label>
                      <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="Email" v-model="email">
                    </div>
                  </div>
                </div>

                <div class="col-md-3  h-100 justify-content-center align-self-center">
                  <button v-if="emailButton == false" class="btn btn-warning" @click="resetEmail">Reset</button>
                  <button v-if="emailButton == false" class="btn btn-success" @click="sendEmailChange">Save Email</button>
                </div>
              </div>

              <hr class="bg-dark">
              <div class="row"><!--  name row -->

                <div class="col-md-3 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Customer Facing Phone</span>
                </div>

                <div class="col-md-6">
                  <div class="row">
                    
                    <div class="form-group col-md-6">
                      <label for="exampleInputEmail1">Phone Number</label>
                      <VuePhoneNumberInput 
                          :translations="{
                            phoneNumberLabel: 'Customer Facing Phone',
                          }"
                          v-model="phone"
                          class="w-100"
                          default-country-code="US"
                          no-country-selector
                          no-validator-state

                        />
                    </div>

                  </div>
                </div>

                <div class="col-md-3  h-100 justify-content-center align-self-center">
                  <button v-if="phoneButton == false" class="btn btn-warning" @click="resetPhone">Reset</button>
                  <button v-if="phoneButton == false" @click="sendPhoneChange" class="btn btn-success">Save Phone</button>
                </div>
              </div>

              

              <hr class="bg-dark">

              
        </div>
      </div>



    </div> <!--  initial column end -->
  </div> <!--  initial row end -->

</div> <!-- root element end -->
</template>


<script>
import {store} from '../../stores/settings-store.js'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {
  store,
  data: function () {
    return { 
      email: '',
      phone: '',
    }
  },
  computed: {
    profileData() { return this.$store.state.profileData },
    profileDataComp() { return this.$store.state.profileDataComp },

    phoneButton: function(){
      var _this = this;
      var phoneFormat = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
      if((_this.phone != _this.profileData.c_phone ) && _this.phone != '' &&  _this.phone != null && _this.phone.match(phoneFormat)) {
        return false;
      } else {
        return true;
      }
    },
    emailButton: function(){
      var _this = this;
      if(_this.email != _this.profileData.c_email && _this.email != '' &&  _this.email != null) {
        return false;
      } else {
        return true;
      }
    },

  },
  watch: {
    profileData() { this.onOpen(); }
  },
  mounted() {
    this.onOpen();
  },
  methods: {
    onOpen() {
      var _this = this;
      _this.email = _this.profileData.c_email;
      _this.phone = _this.profileData.c_phone;
    },
    resetEmail() {
      var _this = this;
      _this.email = _this.profileData.c_email;
    },
    resetPhone() {
      var _this = this;
      _this.phone = _this.profileData.c_phone;
    },
    
    sendEmailChange() {
      var _this = this;
      _this.$toastr.warning('Validating email information.', 'Please wait!')
      var valErrors = [];
      var mailformat = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      if(_this.email == '' || _this.email == null) {  valErrors.push("An email is required!") } else { if(!_this.email.match(mailformat)) { valErrors.push("The customer facing email you entered is invalid!") } }
      if(valErrors.length > 0) {
        _this.$toastr.remove();
        _this.errorDisplay(valErrors);
        return false;
      } 
      _this.$toastr.remove()
      axios.post('/utility/user/profile/updateemail', {
        prof_id: _this.profileData.id,
        email: _this.email,
      })
      .then(function (response) {
        var msg = response.data.msg;
        _this.$toastr.remove()
        _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
        _this.$emit('onSComplete', ['profile-edit' ])
      })
      .catch(function (error) {
        _this.$toastr.remove()
        var errors = error.response.data.errors;
        _this.errorDisplay(errors);
      })
    },

    sendPhoneChange() {
      var _this = this;
      _this.$toastr.warning('Validating phone information.', 'Please wait!')
      var valErrors = [];
      var phoneFormat = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
      if(_this.phone == '' || _this.phone == null) {  valErrors.push("A phone number is required!") } else { if(!_this.phone.match(phoneFormat)) { valErrors.push("The customer facing phone number you entered is invalid!") } }
      if(valErrors.length > 0) {
        _this.$toastr.remove();
        _this.errorDisplay(valErrors);
        return false;
      } 
      _this.$toastr.remove()
      axios.post('/utility/user/profile/updatephone', {
        prof_id: _this.profileData.id,
        phone: _this.phone,
      })
      .then(function (response) {
        var msg = response.data.msg;
        _this.$toastr.remove()
        _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
        _this.$emit('onSComplete', ['profile-edit' ])
      })
      .catch(function (error) {
        _this.$toastr.remove()
        var errors = error.response.data.errors;
        _this.errorDisplay(errors);
      })
    },

    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },
  },    
  components:{
    VuePhoneNumberInput,
  },
  filters: {

  }
}
</script>
